import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { FullProfileDialogAnimationsEnum } from '../../../../Core/Dialogs/enums/full-profile-dialog-animations.enum';
import { OverlayAnimationStateEnum } from '../../../../Core/Dialogs/enums/overlay-animation.enum';
import { FullProfileAnimationModel } from '../../../../Core/Dialogs/models/full-profile-animation.model';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';
import { SocialListeningQuotaUsageWidgetComponent } from '../../../Shared/components/QuotaUsageWidget/social-listening-quota-usage-widget.component';

import { MediaSubscriptionService } from '../../../../Monitor/Core/services/media-subscription.service';
import { MonitoringQuotaTypesEnum } from '../../../../api/mentions/enum/monitoring-quota-types.enum';
import { AgprComponentStyleEnum } from '../../../../Common/Basic/enums/social-analysis-types.enum';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';


@Component({
    selector: 'agpr-quota-exceeded-banner',
    templateUrl: './quota-exceeded-banner.component.html',
    styleUrls: ['./quota-exceeded-banner.component.scss'],
    standalone: false
})
export class QuotaExceededBannerComponent implements OnInit {

    @Input() overlayContainer: Element;
    @Input() id: string;

    isQuotaExceeded: boolean;

    private subscriptions: Subscription[] = [];

    readonly messageSeverityEnum = messageSeverityEnum;
    readonly agprComponentStyleEnum = AgprComponentStyleEnum;
    readonly buttonTypes = ButtonTypesEnum;

    constructor(
        private ref: ElementRef,
        public coreDialogService: CoreDialogService,
        private mediaSubscriptionService: MediaSubscriptionService,
    ) { }

    ngOnInit() {
        this.subscriptions.push(
            this.mediaSubscriptionService.getIsQuotaExceeded(MonitoringQuotaTypesEnum.SOCIAL_LISTENING).subscribe(isQuotaExceeded => {
                this.isQuotaExceeded = isQuotaExceeded ?? false;
            })
        );

        if (!this.overlayContainer) {
            this.overlayContainer = document.getElementById('main-content');
        }
    }

    openQuotaInformationPanel() {
        const animationTrigger = new BehaviorSubject(
            new FullProfileAnimationModel(
                FullProfileDialogAnimationsEnum.slideInOutAnimation,
                OverlayAnimationStateEnum.open
            )
        );
        const ioModel =  {
            inputs: {
                animationTrigger: animationTrigger,
                overlayContainer: this.overlayContainer
            },
            outputs: {
                dialogClose: (closeAction) => {}
            }
        };
        this.coreDialogService.open(SocialListeningQuotaUsageWidgetComponent, ioModel);
    }
}
